export enum DispositionCode {
  PAYOFF = 'EarlyBuy',
  PREPAY = 'Prepayment',
}

export type HomeTransferStatusType = {
  uuid: string;
  transfer_reviewed: string | null;
  homeowner_contract_id: string;
  ucc_filing_fee_date: string | null;
  credit_requested: string | null;
  credit_reviewed: string | null;
  credit_failed: string | null;
  credit_approved: string | null;
  agreement_date_sent: string | null;
  agreement_complete_date: string | null;
  disposition_code: DispositionCode | null;
  contract_paid_in_full: boolean;
  billing_onboarding_date: string | null;
  transfer_cancelled: boolean;
  date_created: string;
  date_updated: string;
};
